export const SMARTTAG_LAYOUT_STANDARD = {
  contentPaddingClass: "p-2",
  gridClass:
    "grid grid-cols-1 gap-6 md:grid-cols-[minmax(0,1.19fr)_minmax(0,0.81fr)]",
  layoutSurfaceClass: "rounded-lg bg-white p-6 dark:bg-gray-950",
  leftColumnCardClass:
    "min-w-0 rounded-lg border border-gray-200 bg-white p-6 shadow-md dark:border-slate-700 dark:bg-slate-900/40",
  rightColumnClass:
    "min-w-0 flex flex-col items-stretch justify-start gap-6 md:border-l md:border-gray-300 md:pl-6 md:dark:border-slate-700",
  qrCardClass:
    "w-full rounded-lg border border-gray-200 bg-white p-6 shadow-md dark:border-slate-700 dark:bg-slate-900/40",
} as const;
